import { FormService } from '@/services';
import { checkValidForm } from '@/utils/formUtils';
import i18n from '@/i18n';

const defaultHeader = [
    {
        type: 'title',
        title: '',
        isEditing: false,
        isFocusing: false,
        default: 'FORM.title',
    },
    {
        type: 'description',
        title: '',
        isEditing: false,
        isFocusing: false,
        default: 'FORM.desc',
    },
];

const defaultData = [
    {
        type: 'short',
        title: 'FORM.phoneDefault',
        isEditing: false,
        isFocusing: false,
        isRequired: true,
        isDrag: false,
        default: 'FORM.quesTitle',
    },
    {
        type: 'short',
        title: 'FORM.emailDefault',
        isEditing: false,
        isFocusing: false,
        isRequired: true,
        isDrag: false,
        default: 'FORM.quesTitle',
    },
];

const defaultFooter = [
    {
        type: 'thanks',
        isEditing: false,
        isFocusing: false,
        title: '',
        default: 'FORM.thanks_placeholder',
    },
];

export const defaultFormCreate = {
    img: '',
    body: [
        {
            type: 'short',
            title: 'FORM.phoneDefault',
            default: 'FORM.quesTitle',
            isRequired: true,
        },
        {
            type: 'short',
            title: 'FORM.emailDefault',
            default: 'FORM.quesTitle',
            isRequired: true,
        },
    ],
    lang: '',
    footer: [
        {
            type: 'thanks',
            title: '',
            default: 'FORM.thanks_placeholder',
        },
    ],
    header: [
        {
            type: 'title',
            title: '',
            default: 'FORM.title',
        },
        {
            type: 'description',
            title: '',
            default: 'FORM.desc',
        },
    ],
};

const noNeedKey = ['isFocusing', 'isEditing', 'isDrag', 'default'];

export const postProcessFnc = (data) => {
    const QUES_PARMAS = (defaultKey) => [
        ['isEditing', false],
        ['isFocusing', false],
        ['default', `FORM.${defaultKey}`],
    ];
    const CHOICE_PARMAS = (defaultKey) => [
        ['isEditing', false],
        ['default', `FORM.${defaultKey}`],
    ];
    const setParam = (key, val, obj) => (obj[key] = val);

    const setQues = (obj, key) =>
        QUES_PARMAS(key).forEach(([param, val]) => setParam(param, val, obj));
    const setChoice = (obj, key) =>
        CHOICE_PARMAS(key).forEach(([param, val]) => setParam(param, val, obj));

    data.header.forEach((obj) => {
        obj.type === 'title' ? setQues(obj, 'title') : setQues(obj, 'desc');
    });

    data.body.forEach((ques) => {
        if (ques.choices)
            ques.choices.forEach((obj) => setChoice(obj, 'multipleItem'));
        ques.isRequired = ques.isRequired == undefined ? true : ques.isRequired;
        setQues(ques, 'quesTitle');
    });

    data.footer.forEach((obj) => {
        setQues(obj, 'thanks');
    });
};

const restApiFns = {
    index: (context, key, [id, type, page], resolve, reject) => {
        return FormService.callApi('forms', key, {
            path: [id],
            params: {
                type,
                campaignId: id,
            },
        })
            .then((result) => {
                postProcessFnc(result.questions);

                context.commit('CHANGE_DATA', [
                    page ? page : 'formEdit',
                    (data, type) => {
                        data[type] = result.questions;
                    },
                ]);

                context.commit('CHANGE_DATA', [
                    [page ? page : 'formEdit', 'linkId'],
                    (data, [key1, key2]) => {
                        data[key1][key2] = result.campaign_id;
                    },
                ]);

                resolve(result);
            })
            .catch((err) => {
                console.log(err);
                reject(err);
            });
    },
    create: (context, key, campaignId, resolve, reject) => {
        const preProcessFnc = (data, index) => {
            const copied = R.clone(data);

            if (copied.choices) {
                copied.choices = copied.choices.map(preProcessFnc);
            }

            noNeedKey.forEach((key) => (copied[key] = undefined));
            copied.order = index;

            if (copied.type == 'choice') {
                copied.choice = data.choice || data.default;
                copied.choice = copied.choice.replace(/\n/g, '<br>');
            } else {
                copied.title = data.title || data.default;
                copied.title = copied.title.replace(/\n/g, '<br>');
            }

            return copied;
        };

        return FormService.callApi('forms', key, {
            path: [campaignId],
            data: {
                img: context.state.formCreate.img,
                header: context.state.formCreate.header.map(preProcessFnc),
                body: context.state.formCreate.body.map(preProcessFnc),
                footer: context.state.formCreate.footer.map(preProcessFnc),
                lang: i18n.locale,
            },
        })
            .then((result) => {
                context.commit('CHANGE_DATA', [
                    ['formCreate', 'linkId'],
                    (data, [key1, key2]) => {
                        data[key1][key2] = result.campaign_id;
                    },
                ]);

                resolve(result);
            })
            .catch((err) => {
                console.log(err);
                reject(err);
            });
    },
    update: (context, key, campaignId, resolve, reject) => {
        return FormService.callApi('forms', key, {
            path: [campaignId],
            data: context.state.formEdit,
        })
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                console.log(err);
                reject(err);
            });
    },
};

export default {
    namespaced: true,
    state: {
        nowEditPath: [],
        editables: [],
        headerData: defaultHeader,
        formData: defaultData,
        footerData: defaultFooter,
        title: 'Title',
        isEditingTitle: false,
        isFocusingTitle: false,
        desc: 'Description',
        isEditingDes: false,
        isFocusingDes: false,
        thanks: '',
        imgSrc: '',
        checkingValidation: false,
        formCreate: {
            img: '',
            header: R.clone(defaultHeader),
            body: R.clone(defaultData),
            footer: R.clone(defaultFooter),
        },
        formEdit: {
            img: '',
            header: R.clone(defaultHeader),
            body: R.clone(defaultData),
            footer: R.clone(defaultFooter),
        },
        formResultData: {
            header: [],
            body: [],
            footer: [],
        },
    },
    mutations: {
        SET_DATA: (state, [type, result]) => {
            postProcessFnc(result);
            state[type] = result;
        },
        CHANGE_DATA: (state, [type, func]) => {
            func(state, type);
        },
        REMOVE_DATA: (state, [type, func]) => {
            func(state, type);
        },
        SET_CHECKING_VALIDATION(state, value) {
            state.checkingValidation = value;
        },
    },
    actions: {
        // when get a data from server
        setData: (context, [type, data]) => {
            context.commit('SET_DATA', [type, data]);
        },
        clearData: (context, [type]) => {
            //set default
            context.commit('CHANGE_DATA', [
                type,
                (state, type) => {
                    state[type] = {
                        img: '',
                        header: R.clone(defaultHeader),
                        body: R.clone(defaultData),
                        footer: R.clone(defaultFooter),
                    };
                },
            ]);
        },
        // when changed only in local
        changeData: (context, [type, func]) => {
            context.commit('CHANGE_DATA', [type, func]);
        },
        removeData: (context, [type, func]) => {
            //especially for turn off edit, focus
            context.commit('REMOVE_DATA', [type, func]);
        },
        restApi: (context, [key, data, resolve, reject]) => {
            return restApiFns[key](context, key, data, resolve, reject);
        },
    },
    getters: {
        nowEditRef: R.prop('nowEditRef'),
        editables: R.prop('editables'),
        formData: R.compose(
            R.clone,
            R.prop('formData')
        ),
        formUsersHeader: R.compose(
            R.map((data) => ({
                type: data.type,
                title: data.title,
            })),
            R.prop('headerData')
        ),
        headerData: R.prop('headerData'),
        thanksMessage: R.compose(
            String,
            R.pluck('title'),
            R.path(['formCreate', 'footer'])
        ),
        title: R.prop('title'),
        desc: R.prop('desc'),
        thanks: R.prop('thanks'),
        imgSrc: R.prop('imgSrc'),
        nowEditPath: R.prop('nowEditPath'),
        formCreate: R.prop('formCreate'),
        formEdit: R.prop('formEdit'),
        checkingValidation: R.prop('checkingValidation'),
        invalidHeader: R.compose(
            checkValidForm,
            R.pathOr([], ['formCreate', 'header'])
        ),
        invalidBody: R.compose(
            checkValidForm,
            R.pathOr([], ['formCreate', 'body'])
        ),
        invalidQues: (_, { invalidHeader, invalidBody }) => [
            ...invalidHeader,
            ...invalidBody,
        ],
        formHasBlank: (_, { invalidQues }) => !!invalidQues.length,
        formHasNoBody: R.compose(
            R.not,
            R.length,
            R.pathOr([], ['formCreate', 'body'])
        ),
        basicQues: R.always({
            short: {
                type: 'short',
                title: '',
                isEditing: false,
                isFocusing: false,
                isDrag: true,
                isRequired: true,
                default: 'FORM.quesTitle',
            },
            multiple: {
                type: 'multiple',
                title: '',
                isEditing: false,
                isFocusing: false,
                isDrag: true,
                isRequired: true,
                default: 'FORM.quesTitle',
                choices: [
                    {
                        type: 'choice',
                        choice: '',
                        isEditing: false,
                        default: 'FORM.multipleItem',
                    },
                    {
                        type: 'choice',
                        choice: '',
                        isEditing: false,
                        default: 'FORM.multipleItem',
                    },
                ],
            },
            checkbox: {
                type: 'checkbox',
                title: '',
                isEditing: false,
                isFocusing: false,
                isDrag: true,
                isRequired: true,
                default: 'FORM.quesTitle',
                choices: [
                    {
                        type: 'choice',
                        choice: '',
                        isEditing: false,
                        default: 'FORM.multipleItem',
                    },
                    {
                        type: 'choice',
                        choice: '',
                        isEditing: false,
                        default: 'FORM.multipleItem',
                    },
                ],
            },
        }),
        emptyChoice: R.always({
            type: 'choice',
            choice: '',
            isEditing: false,
            default: 'FORM.multipleItem',
        }),
    },
};
